export const KEYS = {
  DEFAULT: {
    CONFIG_ERROR: 'Konfigurationsfehler',
    ERROR_TENANT_UNCONFIGURED: 'Die Applikation kann nicht ausgeführt werden. Bitte konfigurieren Sie eine Mandanten-Id für die Domain: <b>[[domain]]</b>'
  }
};
